import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import i18n from '../locales/i18n'
import Home from '../views/Home.vue'
import Room from '../views/Room.vue'
import Camera from '../views/Camera.vue'
import ContentWrapper from '../views/ContentWrapper.vue'
import Image from '../views/Image.vue'
import Video from '../views/Video.vue'
import { setLanguage } from '@/utils/language-utils';



Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
    .catch(err => {
      if (err.name != "NavigationDuplicated") {
        throw err;
      }
    })
};

const routes = [
  {
    path: '/:lang',
    component: Home,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage
      }else {
        i18n.locale = 'en';
      }
      
      next();
    }
  },
  {
    path: '/:lang/room',
    component: Room,
    beforeEnter(to, from, next) {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage
      }else {
        i18n.locale = 'en';
        return next('/en');
      }
      
      if (store.state.twilio.room) {
        next();
      } else {
        next(`/${lang}`); // redirect πίσω στην αρχική με γλώσσα
      }
    },
    children: [
      {
        path: "/",
        redirect: 'camera'
      },
      {
        path: 'camera',
        component: Camera
      },
      {
        path: 'content',
        component: ContentWrapper,
        children: [
          {
            path: "/",
            redirect: to => {
              const lang = to.params.lang || 'en'
              return `/${lang}/room/camera`
            }          },
          {
            path: 'image',
            component: Image
          },
          {
            path: 'video',
            component: Video
          },
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: to => {
      const lang = to.params.lang || 'en' // αν δεν έχει lang πάμε default en
      return `/${lang}/room/camera`
    }
    
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
